import React from 'react';
import DragAndDropUploader from 'components/UI/ImageUploader/DragAndDropUploader';

export const PhotoUploadComponent = ({
  field, // { name, value, onChange, onBlur }
  form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc,
  initialFileList,
  vessel_id,
  hidden,
  ...props
}) => {
  const onChange = value => {
    form.setFieldValue(field.name, value);
    props.onChange && props.onChange(value);
  };
  return (
    <DragAndDropUploader
      hidden={hidden}
      name={field ? field.name : 'documents'}
      value={field ? field.value : []}
      onUploadChange={onChange}
      initialFileList={initialFileList}
      vessel_id={vessel_id}
      apiProps={{
        attachment_type: props.attachmentType
      }}
      accept={props.accept || ''}
    />
  );
};
